<template>
    <div class="container">
        <div class="paramForm">
            <el-form :model="params" label-width="90px">
                <el-row>
                    <el-form-item label="会员地址">
                        <el-input v-model="params.memberAddress" clearable  class="param-address"></el-input>
                    </el-form-item>
                </el-row>
            </el-form>
            <div class="paramFormButton">
                <el-button type="primary" icon="el-icon-search" @click="handleCurrentChange(1)">搜索</el-button>
            </div>
        </div>
        <div class="tableTool2">
            <el-button type="primary" icon="el-icon-printer" @click="exportExcel">导出</el-button>
            <div class="toolRight">
                <div class="ps" style="margin-right:20px;">社区奖励：已发放总金额：{{ countData.ISSUED }} USDT , 待发放总金额：{{ countData.PENDING }} USDT</div>
                <el-button type="primary" @click="sendRward" >发放社区奖励</el-button>
            </div>
        </div>
        <el-table border ref="tableRef" id="out-table" :data="tableData" class="table-show-current" highlight-current-row>
            <el-table-column align="center" prop="id" label="ID" width="80"></el-table-column>
            <el-table-column align="center" label="会员地址" width="150" class-name="address">
                <template slot-scope="scope" v-if="scope.row.memberAddress">
                    <span  v-clipboard:copy="scope.row.memberAddress" v-clipboard:success="onCopy">
                        {{scope.row.memberAddress.slice(0,5) + "..." + scope.row.memberAddress.slice(-5)}}<i class="el-icon-document-copy"/>
                    </span>
                </template>
            </el-table-column>
            <el-table-column prop="type" label="奖励类型" align="center">
                <template slot-scope="scope">{{scope.row.type == 'COMMUNITY'?"社区奖励":"节点奖励"}}</template>
            </el-table-column>
            <el-table-column prop="amount" label="奖励金额" align="center">
                <template slot-scope="scope">{{ scope.row.amount }} USDT</template>
            </el-table-column>
            <el-table-column prop="createdAt" align="center" label="结算时间"> </el-table-column>
            <el-table-column prop="status" align="center" label="发放状态">
                <template slot-scope="scope">{{ scope.row.status=="PENDING"?"待发放":"已发放" }}</template>
            </el-table-column>
            <el-table-column prop="updatedAt" label="更新时间" align="center" width="150"></el-table-column>
        </el-table>
        <div class="pagination">
            <el-pagination
                background
                layout="total,sizes, prev, pager, next"
                :current-page="pageInfo.pageNum"
                :page-size="pageInfo.pageSize"
                :page-sizes="[10, 20, 50, 100, 200]"
                :total="total"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
            ></el-pagination>
        </div>
    </div>
</template>
<script>
import { aldServiceApi } from '@/api/api-ald';
import { exportData1,exportData2 } from '@/assets/js/exportExcel';
export default {
    data() {
        return {
            params: { type:"COMMUNITY" },
            countData:{ PENDING:0, ISSUED:0 },
            total:0,
            pageInfo: {
                pageNum: 1,
                pageSize: 10
            },
            tableData:[],
        };
    },
    created() {
        this.reload()
    },
    methods: {
        onCopy() {
            this.$message.success({message: "复制成功",duration: 600})
        },
        reload(){
            this.handleCurrentChange(1);
            aldServiceApi.countReward(this.params).then(res => {
                this.countData = res;
                this.hideLoadingBox();
            });
        },
        handleSizeChange(val) {
            this.pageInfo.pageSize = val;
            this.handleSearch();
        },
        handleCurrentChange(val) {
            this.pageInfo.pageNum = val;
            this.handleSearch();
        },
        handleSearch() {
            aldServiceApi.findRewardPageList(this.params,this.pageInfo).then(res => {
                this.tableData = res.records;
                this.total = res.total || 0;
                this.hideLoadingBox();
            });
        },
        sendRward(){
            if(this.countData.PENDING <=0){
                this.$message.warning({message: "没有待发放的社区奖励",duration: 1500})
                return;
            }
            this.$confirm('确认要发放社区奖励吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                aldServiceApi.sendRward(this.params).then(res => {
                    if (res.result) {
                        this.showLoadingBox();
                        this.reload();
                        this.$message.success("发放完成");
                    } else {
                        if(res.msg){
                            this.$message.error(res.msg);
                        }else{
                            this.$message.error("发放失败");
                        }
                    }
                });
            });
            
        },
        exportExcel() {
            if(!this.tableData || this.tableData.length==0){
                this.$message.warning({message: "没有可导出的数据",duration: 600})
                return;
            }
            let header = ['ID', '会员地址','奖励类型',"奖励金额","结算时间","发放状态","更新时间"];
            let columns = ['id','memberAddress','type','amount', 'createdAt','status', 'updatedAt'];
            let data = this.tableData.map(r => columns.map(c => {
                let val = r[c];
                return val;
            }));
            exportData2(header,data,"社区奖励记录");
        }
    }
};
</script>

<style lang='less' scope>
span.status_CANCEL{
    color:red;
}
span.status_CONFIRM{
    color:green;
}
span.status_PENDING{
    color:gray;
}
</style>